import type { AihubLayoutConfig } from 'ecosystem'

/** `layout.aihub` with defaults applied: omitted/undefined = shown, only `false` hides. */
export const resolveAihubVisibility = (config?: AihubLayoutConfig) => {
  const showOnDesktop = config?.showOnDesktop !== false
  const showOnTablet = config?.showOnTablet !== false
  const showOnMobile = config?.showOnMobile !== false

  return {
    showOnDesktop,
    showOnTablet,
    showOnMobile,
    isVisibleAnywhere: showOnDesktop || showOnTablet || showOnMobile,
    /** Tablet and mobile both open the hub from the top-nav trigger. */
    isNavTriggerVisible: showOnTablet || showOnMobile
  }
}

/**
 * Responsive `display` for the top-nav trigger (and its nav wrapper): shown on the mobile and
 * tablet tiers it is enabled for, never on desktop (the edge tab covers that).
 */
export const getAihubNavTriggerDisplay = (config: AihubLayoutConfig | undefined, shown: string) => {
  const { showOnMobile, showOnTablet } = resolveAihubVisibility(config)

  return {
    base: showOnMobile ? shown : 'none',
    sm: showOnTablet ? shown : 'none',
    md: 'none'
  }
}

export type AihubVisibility = ReturnType<typeof resolveAihubVisibility>
